import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=78f6c660&scoped=true"
import script from "./CompanyData.vue?vue&type=script&lang=js"
export * from "./CompanyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f6c660",
  null
  
)

export default component.exports